define(["require", "exports", "tslib", "@material-ui/core/Button", "@material-ui/core/colors", "@material-ui/core/styles", "mobx-react", "react", "../../store/UIStore", "../../utils/MathUtil"], function (require, exports, tslib_1, Button_1, colors_1, styles_1, mobx_react_1, React, UIStore_1, MathUtil_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.CtaButton = void 0;
    Button_1 = tslib_1.__importDefault(Button_1);
    React = tslib_1.__importStar(React);
    const theme = (0, styles_1.createTheme)({
        palette: {
            primary: {
                contrastText: colors_1.cyan["400"],
                dark: colors_1.grey["300"],
                main: colors_1.grey["200"]
            }
        },
        overrides: {
            MuiButton: {
                contained: {
                    boxShadow: UIStore_1.boxShadow
                }
            }
        }
    });
    exports.CtaButton = (0, mobx_react_1.observer)((props) => {
        return React.createElement(styles_1.MuiThemeProvider, { theme: props.theme || theme, key: props.id || props.label || `tt-${(0, MathUtil_1.random)()}` },
            React.createElement("div", null,
                React.createElement(Button_1.default, { className: "ctaButton", onClick: props.onClick, disabled: props.disabled, color: props.color, variant: props.variant || "contained", autoFocus: props.autoFocus }, props.label)));
    });
    exports.default = exports.CtaButton;
});
